import React from 'react';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import '../styles/AboutPage.css';

const AboutPage = () => {
  return (
    <div className="about-page">
      <NavBar />
      <div className="about-container">
        <div className="about-header">
          <h1>About Pocket Videoke</h1>
          <p className="subtitle">Your Personal Karaoke Companion</p>
        </div>

        <div className="about-content">
          <section className="about-section">
            <h2>Our Story</h2>
            <p>
              Pocket Videoke was born from a simple idea: making karaoke accessible to everyone, 
              anywhere, anytime. We believe that music has the power to bring people together, 
              create lasting memories, and make any moment special.
            </p>
          </section>

          <section className="about-section">
            <h2>Our Mission</h2>
            <p>
              To revolutionize the karaoke experience by providing a seamless, 
              high-quality platform that connects people through music and entertainment. 
              We strive to make singing accessible, enjoyable, and memorable for everyone.
            </p>
          </section>

          <section className="about-section features">
            <h2>What Sets Us Apart</h2>
            <div className="features-grid">
              <div className="feature-card">
                <i className="fas fa-mobile-alt"></i>
                <h3>Mobile First</h3>
                <p>Take your karaoke experience anywhere with our mobile-friendly platform.</p>
              </div>
              <div className="feature-card">
                <i className="fas fa-cast"></i>
                <h3>Smart TV Integration</h3>
                <p>Cast your karaoke session to any smart TV or Chromecast device.</p>
              </div>
              <div className="feature-card">
                <i className="fas fa-music"></i>
                <h3>Vast Song Library</h3>
                <p>Access thousands of songs across different genres and languages.</p>
              </div>
              <div className="feature-card">
                <i className="fas fa-users"></i>
                <h3>Social Experience</h3>
                <p>Share your sessions with friends and family for a more engaging experience.</p>
              </div>
            </div>
          </section>

          <section className="about-section team">
            <h2>Meet Our Team</h2>
            <p>
              Behind Pocket Videoke is a passionate team of music lovers, developers, 
              and innovators dedicated to creating the best karaoke experience for our users.
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AboutPage; 